import request from '../services/request';

export function uploadImageFile(data, configs) {
  return request({
    url: `/image`,
    method: 'POST',
    timeout: 100000,
    data,
    ...configs,
  });
}

export function updateImageFile(id, data) {
  return request({
    url: `/image/${id}`,
    method: 'PUT',
    data,
  });
}

// ----- borra la imagen y el registro de mongo asociado
export function destroyImageFile(id) {
  return request({
    url: `/image/${id}`,
    method: 'DELETE',
  });
}

// ---- borra la imagen sin registro usado para profile admin
export function deleteImageFile(data) {
  return request({
    url: `/image/delete`,
    method: 'POST',
    data,
  });
}
